export const sampleImage = 'https://d1u57wxxsxzpd6.cloudfront.net/c870eb60-46cb-4254-9d36-ac2ab9b68c2a_sample';

export const sampleExtraction = [
  { coords:     [[772.0, 62.0], [982.0, 62.0], [982.0, 134.0], [772.0, 134.0]],
    text:       'YQ-8',
    confidence: 0.9826083183288574,
    'y-pos':    [982.0, 62.0],
    line:       0 },
  { coords:     [[622.0, 136.0], [1132.0, 132.0], [1132.0, 166.0], [622.0, 170.0]],
    text:       'SuuKee Coffee @ One North MRT',
    confidence: 0.9313318133354187,
    'y-pos':    [1132.0, 132.0],
    line:       1 },
  { coords:     [[446.0, 178.0], [1306.0, 170.0], [1306.0, 204.0], [446.0, 212.0]],
    text:       '9 Ayer Rajah Avenue. B2-03 one-north MRT Station',
    confidence: 0.9337935447692871,
    'y-pos':    [1306.0, 170.0],
    line:       2 },
  { coords:     [[768.0, 216.0], [985.0, 210.0], [986.0, 250.0], [769.0, 256.0]],
    text:       '138647SG',
    confidence: 0.9943031668663025,
    'y-pos':    [985.0, 210.0],
    line:       3 },
  { coords:     [[674.0, 302.0], [1076.0, 300.0], [1076.0, 340.0], [674.0, 342.0]],
    text:       'GST Reg No:202242800W',
    confidence: 0.9421536326408386,
    'y-pos':    [1076.0, 300.0],
    line:       4 },
  { coords:     [[438.0, 448.0], [768.0, 444.0], [768.0, 484.0], [438.0, 488.0]],
    text:       'Order Number:YQ-8',
    confidence: 0.9491859674453735,
    'y-pos':    [768.0, 444.0],
    line:       5 },
  { coords:     [[438.0, 496.0], [1040.0, 492.0], [1040.0, 532.0], [438.0, 536.0]],
    text:       'Date& Time:23/01/2025 @07:46am',
    confidence: 0.9383827447891235,
    'y-pos':    [1040.0, 492.0],
    line:       6 },
  { coords:     [[442.0, 544.0], [822.0, 544.0], [822.0, 584.0], [442.0, 584.0]],
    text:       'Service Type: Dine In',
    confidence: 0.9284957051277161,
    'y-pos':    [822.0, 544.0],
    line:       7 },
  { coords:     [[448.0, 690.0], [1052.0, 686.0], [1052.0, 726.0], [448.0, 730.0]],
    text:       '1 x Orh Nee Pork F1oss Set $7.40)',
    confidence: 0.9223149418830872,
    'y-pos':    [1052.0, 686.0],
    line:       8 },
  { coords:     [[486.0, 740.0], [876.0, 740.0], [876.0, 774.0], [486.0, 774.0]],
    text:       '1 x Orh Nee Pork F1oss',
    confidence: 0.9230448007583618,
    'y-pos':    [876.0, 740.0],
    line:       9 },
  { coords:     [[484.0, 784.0], [1306.0, 780.0], [1306.0, 822.0], [484.0, 826.0]],
    text:       '1 x 2 Soft Eggs (Hard-boiled eggs unavailable)',
    confidence: 0.9420832991600037,
    'y-pos':    [1306.0, 780.0],
    line:       10 },
  { coords:     [[487.0, 828.0], [722.0, 832.0], [721.0, 874.0], [486.0, 870.0]],
    text:       '1 x Yuan Yang',
    confidence: 0.9256765842437744,
    'y-pos':    [722.0, 832.0],
    line:       11 },
  { coords:     [[490.0, 880.0], [788.0, 880.0], [788.0, 920.0], [490.0, 920.0]],
    text:       '1 x Hot Regular)',
    confidence: 0.9088810682296753,
    'y-pos':    [788.0, 880.0],
    line:       12 },
  { coords:     [[490.0, 926.0], [774.0, 926.0], [774.0, 966.0], [490.0, 966.0]],
    text:       '1 x Norma1 Sweet',
    confidence: 0.903700053691864,
    'y-pos':    [774.0, 926.0],
    line:       13 },
  { coords: [[464.0, 1114.0],
    [742.0, 1114.0],
    [742.0, 1148.0],
    [464.0, 1148.0]],
  text:       'Sub Tota1:$7.40',
  confidence: 0.9192251563072205,
  'y-pos':    [742.0, 1114.0],
  line:       14 },
  { coords: [[466.0, 1160.0],
    [842.0, 1160.0],
    [842.0, 1194.0],
    [466.0, 1194.0]],
  text:       'GST Inclusive$0.61',
  confidence: 0.9484971165657043,
  'y-pos':    [842.0, 1160.0],
  line:       15 },
  { coords: [[464.0, 1204.0],
    [676.0, 1204.0],
    [676.0, 1244.0],
    [464.0, 1244.0]],
  text:       'Total:$7.40',
  confidence: 0.9412201046943665,
  'y-pos':    [676.0, 1204.0],
  line:       16 },
  { coords: [[464.0, 1250.0],
    [776.0, 1250.0],
    [776.0, 1290.0],
    [464.0, 1290.0]],
  text:       'Amount Paid:$7.40',
  confidence: 0.9609262943267822,
  'y-pos':    [776.0, 1250.0],
  line:       17 },
  { coords: [[458.0, 1294.0],
    [710.0, 1298.0],
    [710.0, 1340.0],
    [458.0, 1336.0]],
  text:       'Balance:$0.00',
  confidence: 0.9700644016265869,
  'y-pos':    [710.0, 1298.0],
  line:       18 },
  { coords: [[462.0, 1394.0],
    [722.0, 1394.0],
    [722.0, 1428.0],
    [462.0, 1428.0]],
  text:       'CARDHOLDER COPY',
  confidence: 0.9683960676193237,
  'y-pos':    [722.0, 1394.0],
  line:       19 },
  { coords: [[458.0, 1484.0],
    [742.0, 1484.0],
    [742.0, 1524.0],
    [458.0, 1524.0]],
  text:       'Date:23/01/2025',
  confidence: 0.9834892153739929,
  'y-pos':    [742.0, 1484.0],
  line:       20 },
  { coords: [[457.0, 1530.0],
    [704.0, 1534.0],
    [703.0, 1576.0],
    [456.0, 1572.0]],
  text:       'Time:07:46:31',
  confidence: 0.9224783182144165,
  'y-pos':    [704.0, 1534.0],
  line:       21 },
  { coords: [[452.0, 1630.0],
    [702.0, 1630.0],
    [702.0, 1670.0],
    [452.0, 1670.0]],
  text:       'Card:****9342',
  confidence: 0.9603556394577026,
  'y-pos':    [702.0, 1630.0],
  line:       22 },
  { coords: [[450.0, 1680.0],
    [668.0, 1680.0],
    [668.0, 1720.0],
    [450.0, 1720.0]],
  text:       'PAN seq.:00',
  confidence: 0.9080212116241455,
  'y-pos':    [668.0, 1680.0],
  line:       23 },
  { coords: [[450.0, 1728.0],
    [950.0, 1728.0],
    [950.0, 1768.0],
    [450.0, 1768.0]],
  text:       'Pref.name:DEBIT MASTERCARD',
  confidence: 0.9624033570289612,
  'y-pos':    [950.0, 1728.0],
  line:       24 },
  { coords: [[448.0, 1780.0],
    [916.0, 1780.0],
    [916.0, 1820.0],
    [448.0, 1820.0]],
  text:       'Card type: mcstandarddebit',
  confidence: 0.9648967981338501,
  'y-pos':    [916.0, 1780.0],
  line:       25 },
  { coords: [[442.0, 1826.0],
    [774.0, 1830.0],
    [774.0, 1872.0],
    [442.0, 1868.0]],
  text:       'Payment method:mc',
  confidence: 0.9514851570129395,
  'y-pos':    [774.0, 1830.0],
  line:       26 },
  { coords: [[444.0, 1878.0],
    [1022.0, 1878.0],
    [1022.0, 1918.0],
    [444.0, 1918.0]],
  text:       'Payment variant: mcstandarddebit',
  confidence: 0.9605010747909546,
  'y-pos':    [1022.0, 1878.0],
  line:       27 },
];
